// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"y5-z"};